// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"642":"83a2ac55","893":"d6ad73a0"}[chunkId] + ".chunk.js";
};